<template>
	<bootstrap-modal ref="reportModal" :need-header="true" :need-footer="true" :closed="closedModal" size="large">
		<div slot="title">
			<h4 class="modal-title">Selecione as opções para gerar o PDF</h4>
			<div class="alert insurer-inactive alert-danger no-margin-bottom" v-if="downloadDesabilitado">
				<ul>
					<li v-for="(msg, index) in mensagensDeErro" :key="index">
						{{msg}}
					</li>
				</ul>
			</div>
		</div><!-- end title -->

		<div slot="body">
			<div class="row px-25px">
				<div class="col-xs-12 col-sm-12 col-md-1 div-title">Produtos</div>
			</div>
			<div class="row px-25px">
				<div class="col-xs-12 col-sm-12 col-md-6">
					<input type="checkbox" id="chkTodosCalculos" v-model="todosCalculos" @change="selecionarTodosCalculos()">
					<label for="chkTodosCalculos">Selecionar todos os cálculos</label> 
				</div>
				<div class="col-xs-12 col-sm-12 col-md-6">
					<input type="checkbox" id="chkCalculosProdutosAdicionais" v-model="calculosProdutosAdicionais" @change="selecionarCalculosProdutosAdicionais()">
					<label for="chkCalculosProdutosAdicionais">Selecionar produtos adicionais</label> 
				</div>
			</div>
			<hr class="mb-8px"/>
			<div class="row px-25px">
				<div class="col-xs-12 col-sm-offset-6 col-sm-6 col-md-offset-8 col-md-4 text-right">
					<mydropdown ref="theDropdown">
						<div slot="button" >
							<button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" @click.prevent="$refs.theDropdown.toogle()" >
								Filtrar Seguradoras <span class="caret"></span>
							</button>
						</div>
						<ul slot="body" class="dropdown-menu">
							<li v-for="(seguradora, index) in seguradoras" :key="index">
								<a @click="filterBySeguradora(seguradora)">
									<img :src="`https://app.segfy.com/img/companhias/${seguradora.seguradora}_s.png`" alt class="dropdown-seguradora-img">
									<span class="capitalize">{{seguradora.seguradora}}</span>
									<i class="fa fa-check text-success" v-if="seguradora.checked"></i>
								</a>
							</li>
						</ul>
					</mydropdown>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12">
					<div class="orcamentos">
						<div class="row" v-for="(resultado, index) in chkOrcamentos" :key="index">
							<div class="col-xs-12">
								<div class="row">
									<div class="col-xs-12 text-bold">
										Cobertura {{index + 1}} - Tipo: <span class="capitalize">Produto</span> - Franquia: <span class="capitalize">Fanquias</span>
									</div>
								</div>
								<div class="row no-margin">
									<div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 orcamento no-padding" v-for="result in resultado.orcamentos" :key="result.id" :id="result.id"
										@click="addOrRemoveIfExistFromArray(filtros.Calculos, result.value, true, result.extras.status === 'OK' || result.extras.status.toUpperCase() === 'ADDITIONAL_PRODUCT')"
										>      
										<div class="row">
											<div>
												<div class="col-xs-1">
													<input type="checkbox" v-model="filtros.Calculos" :value="result.value" class="seguradora-checkbox" :disabled="result.extras.status !== 'OK' && result.extras.status.toUpperCase() !== 'ADDITIONAL_PRODUCT'">
												</div>
												<div :class="[result.extras.status === 'OK' || result.extras.status.toUpperCase() === 'ADDITIONAL_PRODUCT' ? 'col-xs-4' : 'col-xs-10']" class="text-left">
													<div class="row">
														<div :class="[result.extras.status === 'OK' || result.extras.status.toUpperCase() === 'ADDITIONAL_PRODUCT' ? 'col-xs-4' : 'col-xs-1']">
															<img :src="`https://app.segfy.com/img/companhias/${result.name}_s.png`" alt class="modal-seguradora-img">
														</div>
														<div :class="[result.extras.status === 'OK' || result.extras.status.toUpperCase() === 'ADDITIONAL_PRODUCT' ? 'col-xs-8' : 'col-xs-10']">
															<div class="row seguradora">
																<div class="col-xs-12">{{capitalizeEveryWord(result.name, '_') || '-'}}</div>
															</div>
															<div class="row comissao">
																<div class="col-xs-12">
																	<span v-if="result.extras.status === 'OK' || result.extras.status.toUpperCase() === 'ADDITIONAL_PRODUCT'">{{result.extras.comissao || '0'}}%</span>
																	<span v-else>
																		<i class="fa fa-exclamation-triangle text-yellow"></i> Seguradora apresentou restrição
																	</span>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="col-xs-6 text-right" v-if="result.extras.status === 'OK' || result.extras.status.toUpperCase() === 'ADDITIONAL_PRODUCT'">
													<div class="row valor">
														<div class="col-xs-12">{{result.extras.valor || 'R$ 0,00'}}</div>
													</div>
													<div class="row produto">
														<div v-if="result.extras.status === 'OK'" class="col-xs-12 encurta-texto">{{result.extras.produto || '-'}}</div>
														<div v-else class="col-xs-12 encurta-texto">PRODUTO ADICIONAL</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12 col-sm-offset-6 col-sm-6 col-md-4 col-md-offset-8 px-25px">
					<input type="checkbox" id="chkDadosSegurado" v-model="filtros.IncluirDadosSegurado">
					<label for="chkDadosSegurado">Incluir dados do segurado</label> 
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12 mb-8px">
					<div class="row px-25px">
						<div class="col-xs-12 div-title">Formas de Pagamento</div>
					</div>
					<div class="row px-25px">
						<hr>
					</div>
					<div class="formas-de-pagamento">
						<div class="row">
							<div class="col-xs-12">
								<div class="row">
									<div class="col-xs-12">
										<div class="row">
											<div class="col-xs-6 col-xs-12 col-sm-12 col-md-6 col-md-3" v-for="forma in chkFormasPagamento.geral" :key="forma.id">
												<input type="checkbox" :for="forma.id" v-model="formasSelecionadas.geral" :value="forma.value" :disabled="disabledGeral"
													@click.prevent="selecionarFormasDePagamento(formasSelecionadas.geral, forma.value, true, true, disabledGeral ? true : false)">
												<label :for="forma.id" @click="selecionarFormasDePagamento(formasSelecionadas.geral, forma.value, true, true, disabledGeral)">{{forma.name}}</label>
											</div>
										</div>
									</div>
								</div>

								<div class="row" v-if="verificaSeHaOrcamentoComSeguradora('bradesco')">
									<div class="col-xs-12">
										<div class="row">
											<div class="col-xs-12 text-left">Exclusivo Bradesco</div>
										</div>
										<div class="row">
											<hr>
										</div>
										<div class="row">
											<div class="col-xs-6 col-xs-12 col-sm-12 col-md-6 col-md-3" v-for="forma in chkFormasPagamento.bradesco" :key="forma.id">
												<input type="checkbox" :for="forma.id" v-model="formasSelecionadas.bradesco" :value="forma.value" :disabled="disabledBradesco"
													@click.prevent="selecionarFormasDePagamento(formasSelecionadas.bradesco, forma.value, true, true, disabledBradesco)">
												<label :for="forma.id" @click="selecionarFormasDePagamento(formasSelecionadas.bradesco, forma.value, true, true, disabledBradesco)">{{forma.name}}</label>
											</div>
										</div>
									</div>
								</div>
								
								<div class="row" v-if="verificaSeHaOrcamentoComSeguradora('porto') || verificaSeHaOrcamentoComSeguradora('azul')">
									<div class="col-xs-12">
										<div class="row">
											<div class="col-xs-12 text-left">Exclusivo Porto e Azul</div>
										</div>
										<div class="row">
											<hr>
										</div>
										<div class="row">
											<div class="col-xs-6 col-xs-12 col-sm-12 col-md-6 col-md-3" v-for="forma in chkFormasPagamento.porto" :key="forma.id">
												<input :for="forma.id" type="checkbox" v-model="formasSelecionadas.porto" :value="forma.value" :disabled="disabledPorto"
													@click.prevent="selecionarFormasDePagamento(formasSelecionadas.porto, forma.value, true, true, disabledPorto)">
												<label :for="forma.id" @click="selecionarFormasDePagamento(formasSelecionadas.porto, forma.value, true, true, disabledPorto)">{{forma.name}}</label>
											</div>
										</div>
									</div>
								</div>

								<div class="row" v-if="verificaSeHaOrcamentoComSeguradora('hdi')">
                                    <div class="col-xs-12">
                                        <div class="row">
                                                <div class="col-xs-12 text-left">Exclusivo HDI</div>
                                        </div>
                                        <div class="row">
                                            <hr>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-6 col-xs-12 col-sm-12 col-md-6 col-md-3" v-for="forma in chkFormasPagamento.hdi" :key="forma.id">
                                                <input type="checkbox" :for="forma.id" v-model="formasSelecionadas.hdi" :value="forma.value" :disabled="disabledHdi"
                                                @click.prevent="selecionarFormasDePagamento(formasSelecionadas.hdi, forma.value, true, true, disabledHdi)">
                                                <label :for="forma.id" @click="selecionarFormasDePagamento(formasSelecionadas.hdi, forma.value, true, true, disabledHdi)">{{forma.name}}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row" v-if="verificaSeHaOrcamentoComSeguradora('zurich')">
                                    <div class="col-xs-12">
                                        <div class="row">
                                            <div class="col-xs-12 text-left">Exclusivo Zurich</div>
                                        </div>
                                        <div class="row">
                                            <hr>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-6 col-xs-12 col-sm-12 col-md-6 col-md-3" v-for="forma in chkFormasPagamento.zurich" :key="forma.id">
                                            	<input type="checkbox" :for="forma.id" v-model="formasSelecionadas.zurich" :value="forma.value" :disabled="disabledZurich"
                                            	@click.prevent="selecionarFormasDePagamento(formasSelecionadas.zurich, forma.value, true, true, disabledZurich)">
                                            	<label :for="forma.id" @click="selecionarFormasDePagamento(formasSelecionadas.zurich, forma.value, true, true, disabledZurich)">{{forma.name}}</label>
                                            </div>
                                        </div>
                            		</div>
                                </div> 
							</div>
						</div>
					</div>
					<div class="row px-25px">
                        <div class="col-xs-12">
                            <div class="row">
                                <div class="col-sm-12 col-md-8 div-title">Quantidade de parcelas</div>
                                <div class="col-xs-12 col-sm-6 col-md-4">
                                    <input type="checkbox" id="chkTodasParcelas" v-model="todasParcelas" @change="selecionarTodos(chkParcelas, filtros.ParcelasImprimiveis, todasParcelas)">
                                    <label for="chkTodasParcelas">Selecionar todas as parcelas</label> 
                                </div>
                            </div>
                            <div class="row">
                                <hr>
                            </div>
                            <div class="row">
                                <div class="col-xs-6 col-sm-4 col-md-2" v-for="parcela in chkParcelas" :key="parcela.id">
                                    <input type="checkbox" :id="parcela.id" v-model="filtros.ParcelasImprimiveis" :value="parcela.value">
                                    <label :for="parcela.id">{{parcela.name}}ª parcela</label>
                                </div>
                            </div>
                        </div>
                    </div>
				</div>
			</div>
		</div><!-- end body -->

		<div slot="footer">
			<span class="exibirComissao">
				<input type="checkbox" id="chkExibirComissao" v-model="filtros.ExibirComissao">
				<label for="chkExibirComissao">Exibir Comissão (Resolução 382/20 SUSEP)</label> 
			</span>
			<button type="button" class="btn btn-secondary" @click="hideModal()">Cancelar</button>
			<button type="button" class="btn btn-primary" @click.prevent="imprimir()" :disabled="downloadDesabilitado ? true : false">Baixar PDF</button>
		</div><!-- end footer -->
	</bootstrap-modal>
</template>

<script>
	import BootstrapModal from "vue2-bootstrap-modal"
	import mydropdown from 'vue2-bootstrap-dropdown'

	export default {
		props: ['modalId'],
		components: {
			BootstrapModal,
			mydropdown
		},
		data () {
			return {
				tokenGestao: '',
				quotationId: 0,
				todasParcelas: false,
				todosCalculos: false,
				calculosProdutosAdicionais: false,
				mostrarComRestricao: false,
				mensagensDeErro: [],
				filtros: {
					Token: '',
					Orcamento: '',
					valorFipe: 0,
					Calculos: [],
					ParcelasImprimiveis: [],
					FormasPagamento: [],
					IncluirDadosSegurado: false,
					ExibirComissao: true
				},
				results: {},
				chkFormat: {
					id: '',
					value: '',
					name: '',
					extras: {},
				},
				chkOrcamentos: [],
				chkParcelas: [],
				seguradoras: [],
				seguradorasFiltrada: [],
				disabledGeral: false,
				disabledAlfa: false,
				disabledBradesco: false,
				disabledPorto: false,
				disabledHdi: false,
				disabledZurich: false,
				formasSelecionadas: {
					geral: [],
					alfa: [],
					bradesco: [],
					porto: [],
					hdi: [],
					zurich: []
				},
				chkFormasPagamento: {
					geral: [
						{id: `forma_${this.generateGuid()}`, name: 'Débito', value: 'debito'},
						{id: `forma_${this.generateGuid()}`, name: 'Boleto', value: 'boleto'},
						{id: `forma_${this.generateGuid()}`, name: 'Crédito', value: 'credito'}					
					],
					alfa: [
						{id: `forma_${this.generateGuid()}`, name: 'Ficha | c/boleto', value: 'boleto'},
						{id: `forma_${this.generateGuid()}`, name: 'Débito | c/boleto ', value: 'debito'},
						{id: `forma_${this.generateGuid()}`, name: 'Débito com Boleto', value: 'debitoComBoleto'},
					],
					bradesco: [
						{id: `forma_${this.generateGuid()}`, name: 'Boleto', value: 'boleto'},
						{id: `forma_${this.generateGuid()}`, name: 'Cartão de Crédito', value: 'credito'},
						{id: `forma_${this.generateGuid()}`, name: 'Cartão de Crédito Bradesco', value: 'cartaoBradesco'},
						{id: `forma_${this.generateGuid()}`, name: 'Débito', value: 'debito'}
					],
					porto: [
						{id: `forma_${this.generateGuid()}`, name: '1ª Boleto, Debito', value: 'primeiroBoletoDebito'},
						{id: `forma_${this.generateGuid()}`, name: '1ª Débito, Carne', value: 'primeiroDebitoCarne'}, 
						{id: `forma_${this.generateGuid()}`, name: 'Cartão Porto', value: 'creditoPorto'}, 
						{id: `forma_${this.generateGuid()}`, name: 'A Vista', value: 'avista'},
						{id: `forma_${this.generateGuid()}`, name: 'Boleto', value: 'boleto'},
						{id: `forma_${this.generateGuid()}`, name: 'Crédito - Demais Bandeiras', value: 'credito'},
						{id: `forma_${this.generateGuid()}`, name: 'Débito', value: 'debito'}
					],
					hdi: [
						{id: `forma_${this.generateGuid()}`, name: 'Boleto sem Entrada', value: 'boleto'},
						{id: `forma_${this.generateGuid()}`, name: 'Débito sem Entrada', value: 'debito'},
						{id: `forma_${this.generateGuid()}`, name: 'Débito com Entrada', value: 'debitoComEntrada'},
						{id: `forma_${this.generateGuid()}`, name: 'Boleto com Entrada', value: 'boletoComEntrada'},
						{id: `forma_${this.generateGuid()}`, name: 'Crédito', value: 'credito'},
					],
					zurich: [
						{id: `forma_${this.generateGuid()}`, name: 'Boleto sem Entrada', value: 'boleto'},
						{id: `forma_${this.generateGuid()}`, name: 'Débito sem Entrada', value: 'debito'},
						{id: `forma_${this.generateGuid()}`, name: 'Débito com Entrada', value: 'debitoComEntrada'},
						{id: `forma_${this.generateGuid()}`, name: 'Boleto com Entrada', value: 'boletoComEntrada'},
						{id: `forma_${this.generateGuid()}`, name: 'Crédito', value: 'credito'},
					],
				}
			}
		},
		computed: {
			tokenIntegration(){
				return this.$root.$options.config.token
			},
			downloadDesabilitado() {
				let haFormasSelecionadas = []

				Object.entries(this.formasSelecionadas).forEach(([formasKey, formasValue]) => {
					let existe = this.verificaSeHaOrcamentoComSeguradora(formasKey)
					if (formasKey === 'geral') {
						Object.entries(this.chkFormasPagamento).forEach(([pagamentoKey, pagamentoValue]) => {
							existe = !this.verificaSeHaOrcamentoComSeguradora(pagamentoKey)
						})
					}
					if (existe) {
						if (formasValue.length > 0) haFormasSelecionadas.push(true)
						else haFormasSelecionadas.push(false)
					}
				})

				this.mensagensDeErro = []

				if (this.filtros.Calculos.length === 0) {
					this.addIfNotExist(this.mensagensDeErro, "Selecione ao menos um cálculo para impressão")
				}

				if (haFormasSelecionadas.includes(false)) {
					this.addIfNotExist(this.mensagensDeErro, "Selecione ao menos uma forma de pagamento para cada cálculo selecionado")
				}

				if (this.filtros.ParcelasImprimiveis.length === 0) {
					this.addIfNotExist(this.mensagensDeErro, "Selecione ao menos uma parcela")
				}
			

				return this.filtros.Calculos.length === 0 || haFormasSelecionadas.includes(false)
			},
		},
		created () {
			this.$root.$options.eventBus.$on(
				"updatePrintResults",
				this.updatePrintResults
			)
			this.tokenGestao = $cookies.get('vuex') ? $cookies.get('vuex').auth.token : null
			this.filtros.Token = this.tokenIntegration
		},
		methods: {
			generateGuid() {
				return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
					(
						c ^
						(crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
					).toString(16)
				);
			},
			numberBrazilianPattern (num) {
				return Number(num).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
			},
			brazilianCoin (num, withSpace) {
				let money = null
				if (num != null) {
					money = this.numberBrazilianPattern(num.toString())
					if (money === 'NaN') money = num
				} else {
					money = this.numberBrazilianPattern(0)
				}
				if (withSpace) return `R$ ${money}`
				else return `R$${money}`
			},
			addOrRemoveIfExistFromArray(array,valor,add,doThis) {
				let remove = array.indexOf(valor)
				if (doThis != null && doThis === true) {
					if (remove != null && remove > -1) {
						array.splice(remove, 1)
					} else {
						if (add != null && add != false) array.push(valor)
					}
				}
				return remove
			},
			addIfNotExist(array,valor) {
				let item = array.indexOf(valor)
				if (item == null || item < 0) {
					array.push(valor)
				}
			},
			openModal(modalId) {
				if (this.modalId === modalId) {
					this.$refs.reportModal.open();
				}
			},
			updatePrintResults(modalId, results, quotationId) {
				if (this.modalId == modalId) {
					this.quotationId = quotationId
					this.filtros.Orcamento =`${quotationId}`
					this.results = results
					this.openModal(modalId)
					this.criarCheckBoxsFixo()
					this.getSeguradoras()
					this.filterBySeguradora()
				}
			},
			chamarOrcamentosComRestricao () {
				this.filterBySeguradora()
			},
			getSeguradoras () {
				if (this.seguradoras.length < 1 && this.results != null) {
					let seguradoras = []
					if (this.results.results != null && this.results.results.length > 0) {
						this.results.results.forEach((value, index) => {
						  if (value != null && value.company.name != null && value.company.name != '' && value.company.name !== ' ') {
							  this.addIfNotExist(seguradoras, value.company.name)
						   }
						})
					}
					seguradoras = seguradoras.sort()
					seguradoras.forEach((seguradora) => {
						this.seguradoras.push({seguradora: seguradora, checked: false})
					})
				}
			},
			filterBySeguradora(seguradora) {
				this.criarCheckBoxOrcamentos()
				if (seguradora != null) {
					seguradora.checked = !seguradora.checked
					this.addOrRemoveIfExistFromArray(this.seguradorasFiltrada, seguradora.seguradora, true, true)
				}
				if (this.seguradorasFiltrada.length > 0) {
					this.chkOrcamentos.forEach(resultado => {
						resultado.orcamentos = resultado.orcamentos.filter((orcamento) => {
							let existe = false
							this.seguradorasFiltrada.forEach((seguradora, index) => {
								if (seguradora === orcamento.name) existe = true
							})
							return existe
						})
					})
				}
			},
			criarCheckBoxOrcamentos() {
				this.chkOrcamentos = []
				if (this.results != null && this.results.results != null) {
				   let orcamentos = []
				   
				   this.results.results.forEach((value, index) => {

					   let result = Object.assign({}, this.chkFormat)
					   result.id = `calculo_${value.id}_${this.generateGuid()}`
					   result.name = value.company.name
					   result.value = value.id
					   result.extras = {
						   status: value.status.toUpperCase(),
						   coberturas: value.company_coverages,
						   produto: value.product,
						   comissao: this.results.data.config.insurers.find(elem => elem['company']['name'] == value.company.name)['company']['commission'],
						   valor: this.brazilianCoin(value.premium, true),
						   franquia: this.brazilianCoin(value.franchise, true)
					   }
					   
					   if (this.mostrarComRestricao) {
						   orcamentos.push(result)
					   }
					   else {
						   if (result.extras.status.toUpperCase()  === 'OK' || result.extras.status.toUpperCase()  === 'ADDITIONAL_PRODUCT') {
							   orcamentos.push(result)
						   } else {
							   this.addOrRemoveIfExistFromArray(this.filtros.Calculos, result.value, false, false)
						   }
					   }
				   })
				   orcamentos.sort((a, b) => {
					   let textA = a.name.toUpperCase()
					   let textB = b.name.toUpperCase()
					   return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
				   })
				   this.chkOrcamentos.push({
					   coberturas: this.results.results.company_coverages,
					   orcamentos: orcamentos
				   })
				}
				
			},
			criarCheckBoxsFixo() {
				if (this.chkParcelas.length < 1) {
					for (let i = 1; i <= 12; i++) {
						let parcela = Object.assign({}, this.chkFormat)
						parcela.id = `parcela_${this.generateGuid()}`
						parcela.name = i
						parcela.value = i
						this.chkParcelas.push(parcela)
					}
					this.addOrRemoveIfExistFromArray(this.filtros.ParcelasImprimiveis, 1, true, true)
				}
			},
			imprimir() {
				this.filtros.FormasPagamento = this.formasSelecionadas
				if (this.filtros.ParcelasImprimiveis.length === 0) {
					this.filtros.ParcelasImprimiveis.push(1)
				}
				this.filtros.ParcelasImprimiveis = this.filtros.ParcelasImprimiveis.sort((a, b) => {
						return (Number(a) < Number(b)) ? -1 : (Number(a) > Number(b)) ? 1 : 0
				})

				this.$store.dispatch(
					"exibeMensagemCarregamento",
					"Gerando relatório..."
				);
				let codigoOrcamento = pegaCodigoOrcamento()
				this.$http.post(
				this.$root.$options.config.environment.legadoGestao
					+ '/api/orcamento/AtualizaCotacaoComResultados'
						+ `?codigoOrcamento=${codigoOrcamento}&numeroParcelas=12&mudarStatus=false`,
							this.filtros.Calculos
				)
				.then(response => {
					this.$http
					.post(
						this.$root.$options.config.environment.upfygate +
							"/bgt/api/Budget/ComparisonReport/Generate",
						this.filtros,
						{
							withCredentials: true
						}
					)
					.then(
						response => {
							this.$store.dispatch("closeLoading", 1000);

							let href = "data:application/pdf;base64," + encodeURI(response.data.file)
							var link = document.createElement('a')
							link.target = '_blank'     
							link.href = href
							link.download = response.data.name
							link.click()
							
							hideModal()
						},
						err => {
							this.$store.dispatch(
								"exibeMensagemCarregamento",
								"Erro ao gerar relatório!"
							);
							this.$store.dispatch("closeLoading", 3000);
						}
					);
				},
				err => {
							this.$store.dispatch(
								"exibeMensagemCarregamento",
								"Erro ao gerar relatório!"
							);
							this.$store.dispatch("closeLoading", 3000);
						})
				
			},
			selecionarFormasDePagamento(array,valor,add,doThis,disabledWho) {
				if(array.length < 3) {
					this.addOrRemoveIfExistFromArray(array,valor,true,true)
					if (array.length == 3) disabledWho = true
					else disabledWho = false
				} else {
					let index = this.addOrRemoveIfExistFromArray(array,valor,false,true)
					if (index != null && index > -1) disabledWho = false
					else disabledWho = true
				}
			},
			verificaSeHaOrcamentoComSeguradora(seguradora) {
				let sim = false
				if (this.results != null && this.results.results != null) {
					this.results.results.forEach(r => {
						this.filtros.Calculos.forEach(c => {
							if (c === r.id && seguradora == r.company.name.toLowerCase()) {
								sim = true
							}
						})
					})
				}
				return sim
			},
			selecionarTodos(arrayPai, arrayAlvo, selecionar) {
				if (selecionar) {
					arrayPai.forEach(obj => {
						this.addIfNotExist(arrayAlvo, obj.value)
					})
				} else {
					arrayPai.forEach(obj => {
						this.addOrRemoveIfExistFromArray(arrayAlvo, obj.value, false, true)
					})
				}
			},
			selecionarTodosCalculos () {
				this.chkOrcamentos.forEach(x => {
					if (this.todosCalculos) {
						x.orcamentos.forEach(obj => {
							if (obj.extras.status === 'OK' || obj.extras.status.toUpperCase() === 'ADDITIONAL_PRODUCT') this.addIfNotExist(this.filtros.Calculos, obj.value)
						})
					} else {
						x.orcamentos.forEach(obj => {
							if (obj.extras.status === 'OK' || obj.extras.status.toUpperCase() === 'ADDITIONAL_PRODUCT') this.addOrRemoveIfExistFromArray(this.filtros.Calculos, obj.value, false, true)
						})
					}
				})
			},
			selecionarCalculosProdutosAdicionais () {
				this.chkOrcamentos.forEach(x => {
					if (this.calculosProdutosAdicionais) {
						x.orcamentos.forEach(obj => {
							if (obj.extras.status.toUpperCase() === 'ADDITIONAL_PRODUCT') this.addIfNotExist(this.filtros.Calculos, obj.value)
						})
					} else {
						x.orcamentos.forEach(obj => {
							if (obj.extras.status.toUpperCase() === 'ADDITIONAL_PRODUCT') this.addOrRemoveIfExistFromArray(this.filtros.Calculos, obj.value, false, true)
						})
					}
				})
			},
			capitalizeEveryWord(string, separator) {
				var splitString = string.toLowerCase().split(separator);
				for (let i = 0; i < splitString.length; i++) {
					splitString[i] = this.capitalizeFirstLetter(splitString[i])
				}
				return splitString.join('')
			},
			capitalizeFirstLetter(string) {
				return string.charAt(0).toUpperCase() + string.slice(1)
			},
			hideModal() {			
				this.$refs.reportModal.close();
			}
		}
	}
</script>

<style lang="scss" scoped>
	.more-info-popper {
		width: 273px;
	}

	.no-margin-bottom {
		margin-bottom: 0;
	}

	label {
		font-weight: normal;
	}

	.text-yellow {
		color: #F09637;
	}

	.modal-body {
		overflow: auto !important;
		max-height: 80vh !important;
	}

	.div-title {
		color: #333;
		font-size: 16px;
		line-height: 19px;
	}

	.orcamentos {
		width: 100%;
		height: 23vh;
		padding-left: 18px;
		padding-right: 32px;
		padding-bottom: 5px;
        margin-bottom: 5px;
		overflow: auto;
		box-shadow: 2px 4px 0 -1px rgba(0, 0, 0, .1);
	}

	.formas-de-pagamento {
		width: 100%;
		max-height: 13vh;
		padding-left: 18px;
		padding-right: 32px;
		padding-bottom: 10px;
		margin-bottom: 10px;
		overflow: auto;
		box-shadow: 2px 4px 0 -1px rgba(0, 0, 0, .1);
	}

	.list-style-type-none {
		list-style-type: none;
	}

	.capitalize {
		text-transform: capitalize;
	}
	a.dropdown-toggle {
		color: #555555;
		cursor: pointer;
	}

	.dropdown-menu>li {
		cursor: pointer
	}

	a.dropdown-toggle:hover {
		color: #777
	}

	.mt-minus5px {
		margin-top: -5px
	}

	.mt-10px {
		margin-top: 10px
	}

	.mb-8px {
		margin-bottom: 8px;
	}

	.px-25px {
		padding-left: 25px;
		padding-right: 25px;
	}

	.seguradora-checkbox {
		margin-top: 12px;
		margin-left: 8px;
	}

	.seguradora {
		font-size: 12px;
		color: #333;
		font-weight: bold;
		text-transform: capitalize;
	}

	.comissao>div, .produto>div {
		margin-top: -5px;
	}

	.valor {
		font-size: 12px;
		color:#47B25A;
		font-weight: bold;
	}

	.produto, .comissao {
		font-size: 10px;
		color: #CCC;
	}

	hr {
		color: #999;
		margin-top: 0;
	}

	.orcamento>div { 
		border: 1px solid #E5E5E5;
		border-radius: 5px;
		padding-top: 8px;
		padding-bottom: 8px;
		margin: 3px;
		cursor: pointer;
	}

	.modal-seguradora-img {
		max-height: 24px;
		margin-top: 6px;
	}

	.dropdown-seguradora-img {
		margin-right: 4px;
		max-height: 16px;
	}

	.encurta-texto {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.exibirComissao {
		float: left;
	}
</style>



// WEBPACK FOOTER //
// NewPrintModal.vue?9b7f7be6